import React from 'react'
import PropTypes from 'prop-types'

function Summary({league, type, token, payment}) {
  const forTeam = type == 'team'
  const price = forTeam ? league.team_price : league.individual_price
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`

  return <div className='summary-section'>
    <div className='success'>
      <div className='success__check'><i className='fa fa-check'></i></div>
      <div className='success__title'>Registration Succesful</div>
    </div>
    <div className='summary'>
      <div className='summary__content'>
        <div className='summary-row'>
          <span>Registration Type</span>
          <span>{forTeam ? 'Team' : 'Free Agent'}</span>
        </div>
        <div className='summary-row'>
          <span>Location</span>
          <span>{league.location_name}</span>
        </div>
      </div>
      <div className='summary__price'>
        <div className='summary-row'>
          <span>{`Registration Cost${currencyName}`}</span>
          <span>${parseFloat(price).toFixed(2)}</span>
        </div>
        <div className='summary-row summary-total'>
          <span>{`Total${currencyName}`}</span>
          <span>${parseFloat(price).toFixed(2)}</span>
        </div>
      </div>
      { payment && 
        <div className='summary__payment'>
          <div className='summary-row'>
            <span>Order Date</span>
            <span>{payment.date}</span>
          </div>
          <div className='summary-row'>
            <span>Order Time</span>
            <span>{payment.time}</span>
          </div>
          <div className='summary-row'>
            <span>Payment Method</span>
            <div className='payment-card'>
              <div className={'brand-img' + ` ${payment.brand}-img`}></div>
              <div>{`**** ${payment.last_4}`}</div>
            </div>
          </div>
        </div>
      }
    </div>
    <a className='back-to-list' href={`/plugin/leagues?token=${token}&location_id=${league.location_id}`}>Back to List</a>
  </div>
}

Summary.propTypes = {
  league: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  payment: PropTypes.object.isRequired,
}

export default Summary
